import { useQuery } from 'hooks/useCustomQuery';
import { useSelector } from 'react-redux';
import getPartnerDataStorageLocations from 'API/Partner/getPartnerDataStorageLocations';

const useGetDataResidencyLocations = (setDataResidencyLocations) => {
    const { currentPartner } = useSelector((state) => state.navigationLists);
    return useQuery({
        queryKey: ['dataResidencyLocations'],
        queryFn: async () => {
            const data = await getPartnerDataStorageLocations(
                currentPartner,
            ).then((res) => {
                setDataResidencyLocations(res);
                return res;
            });
            return data;
        },
        refetchOnWindowFocus: false,
        enabled: !!currentPartner,
        staleTime: 0,
    });
};

export default useGetDataResidencyLocations;
